import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import NavigationBar from './components/NavigationBar/NavBar';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Events from './components/Events';
// import Services from './components/Services';
import PressKit from './components/PressKit';
import MediaKit from './components/MediaKit';
import Contact from './components/Contact';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorPage from './components/ErrorPage';
import RouteMetadata from './components/Seo';
import Admin from './components/Admin';
import Lessons from './components/Lessons';
import LessonPreview from './components/Admin/LessonPreview';
import { LESSONS_DEMO } from './api/lessons';
import { LOCAL_PREVIEW } from './localPreview';
import { SUPABASE_URL } from './api/supabase';

function AppContent() {
    const { pathname } = useLocation();
    const isAdmin = pathname === "/admin" || pathname.startsWith("/admin/");

    return (
      <ErrorBoundary>
        <RouteMetadata />
        {LOCAL_PREVIEW && <aside style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 10000, background: '#fff2c6', color: '#332800', padding: '10px 16px', textAlign: 'center' }}>Local database preview · Test data stays on this computer. <a href={`${SUPABASE_URL}/__preview/inbox`} target="_blank" rel="noreferrer">Test email inbox</a></aside>}
        {!isAdmin && <NavigationBar />}
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/presskit" element={<PressKit />} />
            <Route path="/media-kit" element={<MediaKit />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/lessons" element={<Lessons />} />
            {LESSONS_DEMO && <Route path="/admin/lessons" element={<LessonPreview />} />}
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/403" element={<ErrorPage statusCode={403} />} />
            <Route path="/500" element={<ErrorPage statusCode={500} />} />
            <Route path="/503" element={<ErrorPage statusCode={503} />} />
            <Route path="*" element={<ErrorPage statusCode={404} />} />
        </Routes>
        {!isAdmin && <Footer/>}
      </ErrorBoundary>
    );
}

function App() {
    return <Router><AppContent /></Router>;
}

export default App;
